import component from './component.vue';

import Tour from './Tour';

export default {
  install(Vue, { router }) {
    router.addRoutes([
      {
        path: '/admin',
        component,
        children: [
          ...Tour,
        ],
      },
    ]);
  },
};
